import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { connect } from 'react-redux';

// Actions
import { alerts } from 'modules/alerts/actions';
import { actions as modalActions } from 'modules/modals/actions';

// Services
import PurchaseOrder from 'services/data/purchase-order';
import ExpenseBill from 'services/data/expense-bill';

// Components
import EditReturn from './edit-return';
// import { ShippingTaxTotalRow, LineItemRow } from './return-components';
import { ExpenseBillRow, ShippingTaxTotalRow, LineItemRow } from './expense-bill-components';


// Component
class Return extends React.Component {
  static propTypes = {
    expenseBillReturn: PropTypes.object.isRequired,
    currentUser: PropTypes.object.isRequired,
    purchaseOrder: PropTypes.object.isRequired,
    updatePurchaseOrder: PropTypes.func.isRequired
  };

  constructor() {
    super();
    this.state = { editing: false, returning: false };

    this.confirmDelete = this.confirmDelete.bind(this);
    this.deleteExpenseBill = this.deleteExpenseBill.bind(this);
  }

  confirmDelete(expenseBillId, purchaseOrderId) {
    modalActions.showDeleteModal({
      onConfirm: () => this.deleteExpenseBill(expenseBillId, purchaseOrderId),
      title: 'Are you sure you want to delete this charge?',
      body: 'All of the line items will show up back on the purchase order.'
    });
  }

  deleteExpenseBill(expenseBillId, purchaseOrderId) {
    return ExpenseBill.delete(expenseBillId)
      .then(() => PurchaseOrder.findOne(purchaseOrderId, PurchaseOrder.defaultQuery))
      .then(this.props.purchaseOrder.update)
      .catch((err) => {
        const xeroErrorMessage = _.get(err, 'data.Elements.DataContractBase.ValidationErrors.ValidationError.Message');

        if (xeroErrorMessage === 'This Bank Transaction cannot be edited as it has been reconciled with a Bank Statement.') {
          return alerts.error({
            title: 'Couldn\'t delete charge. Charge has been reconciled in Xero.',
            subtitle: 'Contact a Praece administrator if you need to delete this charge.'
          });
        }

        alerts.catchError(err);
      });
  }

  render() {
    const { expenseBillReturn, currentUser, updatePurchaseOrder, purchaseOrder } = this.props;

    if (this.state.editing) {
      return (
        <tbody>
          <EditReturn
            expenseBill={expenseBillReturn}
            cancel={() => this.setState({ editing: false })}
            updatePurchaseOrder={updatePurchaseOrder}
          />
        </tbody>
      );
    }

    return (
      <tbody key={expenseBillReturn.id}>
        <ExpenseBillRow
          purchaseOrder={purchaseOrder}
          expenseBill={expenseBillReturn}
          currentUser={currentUser}
          deleteExpenseBill={this.confirmDelete}
          edit={() => this.setState({ editing: true })} currentUser={currentUser}
          isReturn
        />
        {_.map(expenseBillReturn.lineItems, (lineItem) =>
          <LineItemRow item={lineItem} key={lineItem.id} isReturn />
        )}
        <ShippingTaxTotalRow amount={expenseBillReturn.shipping} description={expenseBillReturn.shipping > 0 ? 'Shipping Fee' : 'Shipping Refund'} isReturn />
        <ShippingTaxTotalRow amount={expenseBillReturn.tax} description={'Tax Refund'} isReturn />
        <ShippingTaxTotalRow amount={expenseBillReturn.amount} description={'Total Refund'} isReturn />
      </tbody>
    );
  }
}

export default connect((state) => ({ currentUser: state.auth.currentUser }))(Return);



// WEBPACK FOOTER //
// ./app/components/models/purchases/return.js